import { render, staticRenderFns } from "./SearchKnowledgeBase.vue?vue&type=template&id=07a05e96&scoped=true&"
import script from "./SearchKnowledgeBase.vue?vue&type=script&lang=js&"
export * from "./SearchKnowledgeBase.vue?vue&type=script&lang=js&"
import style0 from "./SearchKnowledgeBase.vue?vue&type=style&index=0&id=07a05e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a05e96",
  null
  
)

export default component.exports